import { reactive } from '@vue/reactivity'

const state = reactive({
    content: '',
    thankYouPageId: null,
})

export default state
